import React from 'react';
import PublicArticleHeader from "../components/ui/public-article-header";
import ArticleVisitRequirements from "../components/article-visit-requirements";
import AppButton from "@common/components/app-button";
import {classNames} from "@utils/class-names";
import {useNavigate} from "react-router-dom";


const PublicArticleAdditionalInfoView: React.FC = () => {
    const navigate = useNavigate();
    const clickHandler = () => navigate(-1);

    return (
        <>
            <PublicArticleHeader hidePrintAction={true} hideQrAction={true}/>
            <ArticleVisitRequirements/>
            <div className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur border-t border-outline-mild z-30">
                <div className="max-w-[848px] mx-auto px-6 py-3 flex justify-center gap-x-4 gap-y-2">
                    <AppButton
                        label="Wróć do artykułu"
                        onClick={clickHandler}
                        className={classNames(
                            "bg-transparent hover:bg-on-surface/5 h-12 w-fit px-5 rounded-full",
                            "!text-base text-on-surface leading-5 font-semibold border-[2px] border-on-surface/30"
                        )}
                    />
                </div>
            </div>
        </>
    );
};

export default PublicArticleAdditionalInfoView;


